module.exports = __webpack_public_path__ + "img/bvi_2.423e2cf8.png";